import mapIntance from './map/map';

export const getMapInstance = (map, devices, options) => {
	if (options.mapName in window && !options.forceReload) {
		window[options.mapName].loadInstance(map, options);
		return window[options.mapName];
	}

	const instance = new mapIntance(map, devices, options);
	window[options.mapName] = instance;

	if (devices.length > 0) {
		instance.init(devices);
		instance.eventEmmiterInit();
		instance.initDrawingtool();
	}

	return instance;
};

export const SetMapDevices = (mapName, devices) => {
	if (mapName in window) {
		window[mapName].cleanInstance();
		window[mapName].init(devices);
	}
};
